import React, { useState } from 'react';
import { COLORS } from '../../../../utils/constants';
import { adminAPI } from '../../../../services/api';
import { useAdminToast } from '../../../../hooks/useAdminToast';
import { ModalWrapper } from './ModalComponents';

const MassStatusModal = ({ selectedClients, statuses, onClose, onSuccess }) => {
  const { toast } = useAdminToast();
  const [newStatus, setNewStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!newStatus) return;
    setLoading(true);
    try {
      await adminAPI.massStatusChange(selectedClients, newStatus);
      toast.success(`Статус изменён для ${selectedClients.length} клиентов`);
      onSuccess();
    } catch (err) {
      toast.apiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalWrapper title="Массовое изменение статуса" onClose={onClose}>
      <div style={{ padding: '16px', backgroundColor: COLORS.background, borderRadius: '8px', marginBottom: '16px' }}>
        <div style={{ color: COLORS.textSecondary, fontSize: '13px', marginBottom: '4px' }}>Выбрано клиентов</div>
        <div style={{ color: '#8b5cf6', fontSize: '28px', fontWeight: '700' }}>{selectedClients.length}</div>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>Новый статус</label>
        <select 
          value={newStatus} 
          onChange={(e) => setNewStatus(e.target.value)} 
          style={{ 
            width: '100%', 
            padding: '12px', 
            backgroundColor: COLORS.background, 
            border: `1px solid ${COLORS.border}`, 
            borderRadius: '8px', 
            color: COLORS.text, 
            fontSize: '14px' 
          }}
        >
          <option value="">Выберите статус...</option>
          {statuses.map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>

      <button 
        onClick={handleSubmit} 
        disabled={loading || !newStatus} 
        style={{ 
          width: '100%', 
          padding: '14px', 
          backgroundColor: loading || !newStatus ? COLORS.border : '#8b5cf6', 
          border: 'none', 
          borderRadius: '8px', 
          color: '#fff', 
          fontSize: '15px', 
          fontWeight: '600', 
          cursor: loading || !newStatus ? 'not-allowed' : 'pointer' 
        }}
      >
        {loading ? 'Изменение...' : `Изменить статус на "${newStatus || '...'}"`}
      </button>
    </ModalWrapper>
  );
};

export default MassStatusModal;
